import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import Button from "@mui/material/Button";
import logoemaar from "../../Images/Emaar/Emaar_logo.svg.png";

// ── API ────────────────────────────────────────────────────────
const API_URL =
  "https://homewalkers.realatixcrm.com/api/v1/users/create-with-params" +
  "?addedby=68da45a5b37ddfab3b73bd8b" +
  "&stage=68d110bbad5a0732ad44e5cf" +
  "&Channal=6a48bfa6a4cf5854ad69d511" +
  "&project=6a424455cbc3b90bfa64cd4b" +
  "&salesdata=68da75b5b37ddfab3b7463f5" +
  "&Communicationway=69159308820816f4ad71c3bf" +
  "&campaignid=68e3a33dbd4758877fb945a1" +
  "&includePhone2=false" +
  "&includeWhatsapp=false" +
  "&includeJobDesc=false" +
  "&includeQuestion1=true" +
  "&question1_text=%D8%A7%D9%84%D8%BA%D8%B1%D8%B6++%D9%85%D9%86+%D8%A7%D9%84%D8%B4%D8%B1%D8%A7%D8%A1+%D8%9F" +
  "&includeQuestion2=true" +
  "&question2_text=%D8%B9%D8%AF%D8%AF+%D8%A7%D9%84%D8%BA%D8%B1%D9%81+%D8%9F" +
  "&includeQuestion3=false" +
  "&includeQuestion4=false" +
  "&includeQuestion5=false";

const purposeOptions = ["السكن", "الاستثمار", "سكن واستثمار"];
const roomOptions    = ["استوديو", "1 غرفة", "2 غرفة", "3 غرفة"];

const countryCodes = [
  { iso: "ae", name: "الإمارات",        dial: "+971" },
  { iso: "sa", name: "السعودية",        dial: "+966" },
  { iso: "eg", name: "مصر",             dial: "+20"  },
  { iso: "kw", name: "الكويت",          dial: "+965" },
  { iso: "qa", name: "قطر",             dial: "+974" },
  { iso: "bh", name: "البحرين",         dial: "+973" },
  { iso: "om", name: "عُمان",           dial: "+968" },
  { iso: "jo", name: "الأردن",          dial: "+962" },
  { iso: "lb", name: "لبنان",           dial: "+961" },
  { iso: "iq", name: "العراق",          dial: "+964" },
  { iso: "sy", name: "سوريا",           dial: "+963" },
  { iso: "ye", name: "اليمن",           dial: "+967" },
  { iso: "ps", name: "فلسطين",          dial: "+970" },
  { iso: "ma", name: "المغرب",          dial: "+212" },
  { iso: "dz", name: "الجزائر",         dial: "+213" },
  { iso: "tn", name: "تونس",            dial: "+216" },
  { iso: "ly", name: "ليبيا",           dial: "+218" },
  { iso: "sd", name: "السودان",         dial: "+249" },
  { iso: "us", name: "الولايات المتحدة", dial: "+1"   },
  { iso: "gb", name: "المملكة المتحدة", dial: "+44"  },
  { iso: "in", name: "الهند",           dial: "+91"  },
  { iso: "pk", name: "باكستان",         dial: "+92"  },
];

const inputStyle = {
  width:        "100%",
  padding:      "13px 16px",
  border:       "1.5px solid #e0d8cc",
  borderRadius: "10px",
  fontSize:     "14px",
  fontFamily:   "'Cairo', sans-serif",
  color:        "#1a1a1a",
  background:   "#fff",
  outline:      "none",
  boxSizing:    "border-box",
  direction:    "rtl",
  transition:   "border-color 0.2s ease, box-shadow 0.2s ease",
};

const labelStyle = {
  fontSize:     "13px",
  fontWeight:   "600",
  color:        "#444",
  display:      "block",
  marginBottom: "7px",
  direction:    "rtl",
};

// ========== Booking Modal ==========
const EmaarBookingModal = ({ open, onClose }) => {
  const [formData, setFormData] = useState({
    name: "", phone: "", email: "",
    question1_answer: "السكن", question2_answer: "",
  });
  const [countryIso, setCountryIso] = useState("ae");
  const [loading, setLoading] = useState(false);
  const [alert,   setAlert]   = useState({ show: false, message: "", ok: false });

  const selectedCountry = countryCodes.find((c) => c.iso === countryIso) || countryCodes[0];

  useEffect(() => {
    if (!alert.show) return;
    const t = setTimeout(() => setAlert((p) => ({ ...p, show: false })), 5000);
    return () => clearTimeout(t);
  }, [alert.show]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const handleChange = (field) => (e) =>
    setFormData((p) => ({ ...p, [field]: e.target.value }));

  const handleFocus = (e) => {
    e.target.style.borderColor = "#c8a04a";
    e.target.style.boxShadow   = "0 0 0 3px rgba(200,160,74,0.12)";
  };
  const handleBlur = (e) => {
    e.target.style.borderColor = "#e0d8cc";
    e.target.style.boxShadow   = "none";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const phone = formData.phone.trim();
    if (!phone || phone.replace(/\D/g, "").length < 6)
      return setAlert({ show: true, message: "يرجى إدخال رقم هاتف صحيح", ok: false });

    const fullPhone = `${selectedCountry.dial}${phone.replace(/\D/g, "")}`;
    setLoading(true);
    setAlert({ show: false, message: "", ok: false });

    try {
      const res = await fetch(API_URL, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name:             formData.name.trim() || "no name",
          email:            formData.email.trim().toLowerCase() || "",
          phone:            fullPhone,
          question1_answer: formData.question1_answer,
          question2_answer: formData.question2_answer,
        }),
      });
      if (!res.ok) throw new Error(`${res.status}`);
      setAlert({ show: true, message: "تم الإرسال بنجاح ✅", ok: true });
      setFormData({ name: "", phone: "", email: "", question1_answer: "السكن", question2_answer: "" });
    } catch (err) {
      const status = err.message;
      setAlert({
        show: true, ok: false,
        message:
          status.includes("409") ? "رقم الهاتف مسجّل مسبقاً"
        : status.includes("400") ? "بيانات غير صحيحة، يرجى المراجعة"
        : "حدث خطأ، يرجى المحاولة مجدداً",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div
      onClick={(e) => e.target === e.currentTarget && onClose()}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)",
        zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center",
        padding: "20px", backdropFilter: "blur(4px)", overflowY: "auto",
      }}
    >
      <div style={{
        background: "#fff", borderRadius: "16px",
        padding: "clamp(28px, 5vw, 40px) clamp(22px, 4vw, 36px)",
        width: "100%", maxWidth: "480px", direction: "rtl",
        fontFamily: "'Cairo', sans-serif", position: "relative",
        animation: "fadeInUp 0.35s ease", maxHeight: "90vh",
        overflowY: "auto", boxSizing: "border-box",
      }}>
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: "16px", left: "16px", background: "none",
            border: "none", fontSize: "22px", cursor: "pointer", color: "#888",
            lineHeight: 1, padding: "4px 8px",
          }}
        >✕</button>

        <div style={{ marginBottom: "24px" }}>
          <p style={{
            fontSize: "11px", fontWeight: "700", color: "#c8a04a",
            letterSpacing: "3px", textTransform: "uppercase", margin: "0 0 10px 0",
          }}>EMAAR GOLF FIELD</p>
          <h2 style={{
            fontSize: "clamp(20px, 3vw, 26px)", fontWeight: "900",
            color: "#1a1a1a", margin: "0 0 8px 0", lineHeight: "1.2",
          }}>لمزيد من التفاصيل</h2>
          <p style={{ fontSize: "14px", color: "#888", margin: "0 0 4px 0" }}>
            سجل بياناتك وسنتواصل معك في أقرب وقت
          </p>
          <div style={{
            width: "48px", height: "3px",
            background: "linear-gradient(to left, #c8a04a, #f0d080)",
            borderRadius: "2px", marginTop: "14px",
          }} />
        </div>

        {alert.show && (
          <div style={{
            background: alert.ok ? "rgba(74,124,63,0.08)" : "rgba(200,50,50,0.07)",
            border: `1px solid ${alert.ok ? "rgba(74,124,63,0.3)" : "rgba(200,50,50,0.25)"}`,
            borderRadius: "10px", padding: "11px 16px", marginBottom: "18px",
            fontSize: "14px", fontWeight: "600",
            color: alert.ok ? "#2e5e26" : "#9b2020",
            display: "flex", justifyContent: "space-between", alignItems: "center",
          }}>
            <span>{alert.message}</span>
            <button
              onClick={() => setAlert((p) => ({ ...p, show: false }))}
              style={{ background: "none", border: "none", cursor: "pointer",
                color: "inherit", fontSize: "16px", lineHeight: 1, padding: "0 0 0 8px" }}
            >✕</button>
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label style={labelStyle}>الاسم</label>
            <input type="text" placeholder="الاسم" value={formData.name}
              onChange={handleChange("name")} onFocus={handleFocus} onBlur={handleBlur}
              style={inputStyle} />
          </div>

          <div>
            <label style={labelStyle}>
              رقم الهاتف <span style={{ color: "#c8a04a" }}>*</span>
            </label>
            <div style={{ display: "flex", gap: "8px", direction: "ltr" }}>
              <div style={{ position: "relative", flexShrink: 0, width: "128px" }}>
                <img
                  src={`https://flagcdn.com/w20/${selectedCountry.iso}.png`}
                  alt={selectedCountry.iso}
                  style={{
                    position: "absolute", left: "10px", top: "50%",
                    transform: "translateY(-50%)", width: "20px",
                    borderRadius: "2px", pointerEvents: "none", zIndex: 1,
                  }}
                />
                <select
                  value={countryIso}
                  onChange={(e) => setCountryIso(e.target.value)}
                  onFocus={handleFocus} onBlur={handleBlur}
                  style={{
                    ...inputStyle, direction: "ltr", paddingLeft: "38px", paddingRight: "26px",
                    appearance: "none", WebkitAppearance: "none",
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23c8a04a' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
                    backgroundRepeat: "no-repeat", backgroundPosition: "right 10px center",
                    cursor: "pointer", fontWeight: "600", fontSize: "13px",
                  }}
                >
                  {countryCodes.map((c) => (
                    <option key={c.iso} value={c.iso}>{c.dial} {c.name}</option>
                  ))}
                </select>
              </div>
              <input
                type="tel" placeholder="رقم الهاتف" value={formData.phone}
                onChange={handleChange("phone")} onFocus={handleFocus} onBlur={handleBlur}
                style={{ ...inputStyle, direction: "ltr", textAlign: "right", flex: 1 }}
              />
            </div>
          </div>

          <div>
            <label style={labelStyle}>الإيميل</label>
            <input type="email" placeholder="الإيميل" value={formData.email}
              onChange={handleChange("email")} onFocus={handleFocus} onBlur={handleBlur}
              style={{ ...inputStyle, direction: "ltr", textAlign: "right" }} />
          </div>

          <div>
            <label style={labelStyle}>الغرض من الشراء</label>
            <select
              value={formData.question1_answer}
              onChange={handleChange("question1_answer")}
              onFocus={handleFocus} onBlur={handleBlur}
              style={{
                ...inputStyle, appearance: "none", WebkitAppearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23c8a04a' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat", backgroundPosition: "left 14px center",
                paddingLeft: "36px", cursor: "pointer",
              }}
            >
              {purposeOptions.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
          </div>

          <div>
            <label style={labelStyle}>عدد الغرف</label>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {roomOptions.map((room) => (
                <label key={room} style={{
                  display: "flex", alignItems: "center", gap: "6px", cursor: "pointer",
                  fontSize: "13px", fontWeight: "600",
                  color: formData.question2_answer === room ? "#c8a04a" : "#555",
                  padding: "7px 14px", borderRadius: "8px",
                  border: `1.5px solid ${formData.question2_answer === room ? "#c8a04a" : "#e0d8cc"}`,
                  background: formData.question2_answer === room ? "rgba(200,160,74,0.08)" : "#fff",
                  transition: "all 0.2s ease",
                }}>
                  <input type="radio" name="rooms" value={room}
                    checked={formData.question2_answer === room}
                    onChange={handleChange("question2_answer")}
                    style={{ display: "none" }} />
                  {room}
                </label>
              ))}
            </div>
          </div>

          <button
            type="submit" disabled={loading}
            style={{
              width: "100%", padding: "15px", marginTop: "6px",
              background: loading ? "rgba(200,160,74,0.5)" : "linear-gradient(135deg, #b8903a, #c8a04a, #e0b84a)",
              color: "#fff", border: "none", borderRadius: "12px", fontSize: "16px",
              fontWeight: "700", fontFamily: "'Cairo', sans-serif",
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: "0 6px 20px rgba(200,160,74,0.35)",
              transition: "all 0.25s ease", letterSpacing: "0.5px",
            }}
            onMouseEnter={(e) => { if (!loading) e.target.style.boxShadow = "0 10px 28px rgba(200,160,74,0.5)"; }}
            onMouseLeave={(e) => { e.target.style.boxShadow = "0 6px 20px rgba(200,160,74,0.35)"; }}
          >
            {loading ? "جاري الإرسال..." : "إرسال"}
          </button>
        </form>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

// ========== Emaar Navbar ==========
export const EmaarNavbar = () => {
  const logoRef    = useRef(null);
  const toggleRef  = useRef(null);
  const bookNowRef = useRef(null);
  const drawerRef  = useRef(null);
  const overlayRef = useRef(null);
  const drawerItemsRef = useRef([]);

  const [showModal, setShowModal] = useState(false);
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);

  const tabs = [
    { id: "about",     label: "عن المشروع" },
    { id: "amenities", label: "الخدمات" },
    { id: "location",  label: "الموقع" },
    { id: "map",       label: "الخريطة" },
  ];

  // ─── Scroll ───────────────────────────────────────────────────
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ─── Navbar Entry Animation ───────────────────────────────────
  useEffect(() => {
    gsap.set(logoRef.current,    { opacity: 0, x: 30 });
    gsap.set(toggleRef.current,  { opacity: 0, x: -30 });
    gsap.set(bookNowRef.current, { opacity: 0, scale: 0.8 });

    const tl = gsap.timeline({ delay: 0.2 });
    tl.to(logoRef.current,    { opacity: 1, x: 0, duration: 0.7, ease: "power3.out" })
      .to(bookNowRef.current, { opacity: 1, scale: 1, duration: 0.5, ease: "back.out(1.7)" }, "-=0.3")
      .to(toggleRef.current,  { opacity: 1, x: 0, duration: 0.5, ease: "power3.out" }, "-=0.3");
  }, []);

  // ─── Book Now Pulse ───────────────────────────────────────────
  useEffect(() => {
    const pulse = gsap.to(bookNowRef.current, {
      scale: 1.07, repeat: -1, yoyo: true,
      ease: "sine.inOut", duration: 1, delay: 2,
    });
    return () => pulse.kill();
  }, []);

  // ─── Drawer Open/Close Animation ─────────────────────────────
  useEffect(() => {
    const drawer  = drawerRef.current;
    const overlay = overlayRef.current;
    const items   = drawerItemsRef.current;

    if (menuOpen) {
      document.body.style.overflow = "hidden";
      gsap.to(overlay, { opacity: 1, pointerEvents: "auto", duration: 0.3, ease: "power2.out" });
      gsap.fromTo(drawer,
        { x: "100%", opacity: 0.5 },
        { x: "0%", opacity: 1, duration: 0.45, ease: "power3.out" }
      );
      gsap.fromTo(items,
        { opacity: 0, x: 30 },
        { opacity: 1, x: 0, stagger: 0.07, duration: 0.4, ease: "power3.out", delay: 0.2 }
      );
    } else {
      document.body.style.overflow = "";
      gsap.to(overlay, { opacity: 0, pointerEvents: "none", duration: 0.3 });
      gsap.to(drawer,  { x: "100%", opacity: 0.5, duration: 0.35, ease: "power3.in" });
    }
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      {/* ══════════════════════════════════════════════
          NAVBAR BAR
      ══════════════════════════════════════════════ */}
      <nav
        dir="rtl"
        className="fixed-top"
        style={{
          fontFamily:      "'Cairo', sans-serif",
          zIndex:          1000,
          transition:      "background 0.4s ease, box-shadow 0.4s ease",
          backgroundColor: scrolled ? "rgba(10,10,10,0.96)" : "transparent",
          boxShadow:       scrolled ? "0 2px 24px rgba(0,0,0,0.5)" : "none",
          backdropFilter:  scrolled ? "blur(16px)" : "none",
          borderBottom:    scrolled ? "1px solid rgba(200,160,74,0.2)" : "1px solid transparent",
          padding:         "0.6rem 0",
        }}
      >
        <div className="container d-flex align-items-center justify-content-between">

          {/* Logo */}
          <a href="#" ref={logoRef} style={{ opacity: 0, textDecoration: "none",
            display: "flex", alignItems: "center", gap: "10px" }}>
            <img src={logoemaar} alt="Emaar Logo"
              style={{ height: "clamp(52px, 4.5vw, 42px)", width: "auto" }} />
          </a>

          {/* Right side: Book Now + Hamburger */}
          <div style={{ display: "flex", alignItems: "center",
            gap: "12px", flexDirection: "row-reverse" }}>

            {/* Book Now — ظاهر دايماً */}
            <Button
              ref={bookNowRef}
              variant="contained"
              size="small"
              onClick={() => setShowModal(true)}
              sx={{
                fontFamily:  "'Cairo', sans-serif",
                fontWeight:  700,
                fontSize:    "clamp(0.78rem, 1.4vw, 0.88rem)",
                px:          { xs: 2, md: 3 },
                py:          { xs: 0.7, md: 0.9 },
                borderRadius:"50px",
                opacity:     0,
                letterSpacing: "0.03em",
                background:  "linear-gradient(135deg, #b8903a 0%, #e0b84a 100%)",
                boxShadow:   "0 4px 16px rgba(200,160,74,0.4)",
                "&:hover": {
                  background: "linear-gradient(135deg, #a07e2e 0%, #c8a04a 100%)",
                  boxShadow:  "0 6px 22px rgba(200,160,74,0.55)",
                },
              }}
            >
              {texts(false)}
            </Button>

            {/* Hamburger */}
            {/* <button
              ref={toggleRef}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              style={{
                opacity:      0,
                background:   "rgba(200,160,74,0.18)",
                border:       "1px solid rgba(200,160,74,0.35)",
                borderRadius: "10px",
                padding:      "8px 10px",
                cursor:       "pointer",
                display:      "flex",
                flexDirection:"column",
                gap:          "5px",
                transition:   "background 0.2s ease",
              }}
            >
              {[22, 14, 22].map((w, i) => (
                <span key={i} style={{
                  display:     "block",
                  width:       `${w}px`,
                  height:      "2px",
                  background:  menuOpen ? "#e0b84a" : "rgba(255,255,255,0.85)",
                  borderRadius:"2px",
                  transition:  "all 0.3s ease",
                  transform:   menuOpen && i === 0 ? "rotate(45deg) translate(5px,5px)"
                             : menuOpen && i === 2 ? "rotate(-45deg) translate(5px,-5px)"
                             : menuOpen && i === 1 ? "scaleX(0)" : "none",
                  marginInlineStart: i === 1 ? "4px" : "0",
                }} />
              ))}
            </button> */}
          </div>
        </div>
      </nav>

      {/* ══════════════════════════════════════════════
          OVERLAY
      ══════════════════════════════════════════════ */}
      <div
        ref={overlayRef}
        onClick={closeMenu}
        style={{
          position:       "fixed",
          inset:          0,
          background:     "rgba(0,0,0,0.6)",
          backdropFilter: "blur(3px)",
          zIndex:         1100,
          opacity:        0,
          pointerEvents:  "none",
        }}
      />

      {/* ══════════════════════════════════════════════
          DRAWER
      ══════════════════════════════════════════════ */}
      <div
        ref={drawerRef}
        dir="rtl"
        style={{
          position:        "fixed",
          top:             0,
          right:           0,
          width:           "min(300px, 82vw)",
          height:          "100dvh",
          background:      "linear-gradient(160deg, #161208 0%, #1f1a0c 60%, #0e0c06 100%)",
          borderInlineStart: "1px solid rgba(200,160,74,0.25)",
          zIndex:          1200,
          transform:       "translateX(100%)",
          display:         "flex",
          flexDirection:   "column",
          padding:         "0",
          overflowY:       "auto",
          boxShadow:       "-8px 0 40px rgba(0,0,0,0.6)",
        }}
      >
        {/* Drawer Header */}
        <div
          ref={(el) => (drawerItemsRef.current[0] = el)}
          style={{
            display:        "flex",
            alignItems:     "center",
            justifyContent: "space-between",
            padding:        "20px 24px 16px",
            borderBottom:   "1px solid rgba(200,160,74,0.2)",
            flexDirection:  "row-reverse",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px",
            flexDirection: "row-reverse" }}>
            <img src={logoemaar} alt="Emaar" style={{ height: "26px", width: "auto" }} />
            <span style={{
              fontFamily: "'Cairo', sans-serif",
              fontWeight: 700,
              fontSize:   "1rem",
              color:      "#e0b84a",
              letterSpacing: "0.05em",
            }}>
              القائمة
            </span>
          </div>
          {/* Close Button */}
          <button
            onClick={closeMenu}
            style={{
              background:   "rgba(200,160,74,0.15)",
              border:       "1px solid rgba(200,160,74,0.3)",
              borderRadius: "8px",
              color:        "rgba(255,255,255,0.7)",
              width:        "34px",
              height:       "34px",
              cursor:       "pointer",
              fontSize:     "1.1rem",
              display:      "flex",
              alignItems:   "center",
              justifyContent:"center",
              transition:   "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(200,160,74,0.3)";
              e.currentTarget.style.color      = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(200,160,74,0.15)";
              e.currentTarget.style.color      = "rgba(255,255,255,0.7)";
            }}
          >✕</button>
        </div>

        {/* Nav Links */}
        <nav style={{ padding: "16px 16px", flex: 1 }}>
          {tabs.map((tab, index) => (
            <a key={tab.id} href={`#${tab.id}`}
              ref={(el) => (drawerItemsRef.current[index + 1] = el)}
              onClick={closeMenu}
              style={{
                display:        "flex",
                alignItems:     "center",
                gap:            "12px",
                flexDirection:  "row-reverse",
                padding:        "14px 16px",
                marginBottom:   "4px",
                borderRadius:   "12px",
                textDecoration: "none",
                color:          "rgba(255,255,255,0.82)",
                fontFamily:     "'Cairo', sans-serif",
                fontWeight:     600,
                fontSize:       "1rem",
                border:         "1px solid transparent",
                transition:     "all 0.22s ease",
                background:     "transparent",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background   = "rgba(200,160,74,0.15)";
                e.currentTarget.style.borderColor  = "rgba(200,160,74,0.3)";
                e.currentTarget.style.color        = "#e0b84a";
                e.currentTarget.style.paddingInlineStart = "16px";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background   = "transparent";
                e.currentTarget.style.borderColor  = "transparent";
                e.currentTarget.style.color        = "rgba(255,255,255,0.82)";
                e.currentTarget.style.paddingInlineStart = "16px";
              }}
            >
              <span style={{
                fontFamily:  "'Cairo', sans-serif",
                fontSize:    "0.7rem",
                fontWeight:  700,
                color:       "#c8a04a",
                minWidth:    "20px",
                textAlign:   "center",
                letterSpacing: "0.05em",
              }}>
                0{index + 1}
              </span>
              <span style={{ width: "1px", height: "16px",
                background: "rgba(200,160,74,0.4)" }} />
              {tab.label}
            </a>
          ))}
        </nav>

        {/* Drawer Footer */}
        <div
          ref={(el) => (drawerItemsRef.current[tabs.length + 1] = el)}
          style={{
            padding:     "20px 24px",
            borderTop:   "1px solid rgba(200,160,74,0.2)",
            display:     "flex",
            flexDirection:"column",
            gap:         "12px",
          }}
        >
          {/* Book Now داخل الـ drawer */}
          <Button
            variant="contained"
            fullWidth
            onClick={() => { setShowModal(true); closeMenu(); }}
            sx={{
              fontFamily:   "'Cairo', sans-serif",
              fontWeight:   700,
              fontSize:     "0.95rem",
              py:           1.3,
              borderRadius: "12px",
              letterSpacing:"0.04em",
              background:   "linear-gradient(135deg, #b8903a 0%, #e0b84a 100%)",
              boxShadow:    "0 4px 20px rgba(200,160,74,0.4)",
              "&:hover": {
                background: "linear-gradient(135deg, #a07e2e 0%, #c8a04a 100%)",
                boxShadow:  "0 6px 28px rgba(200,160,74,0.55)",
              },
            }}
          >
             تواصل معنا
          </Button>

          {/* Branding */}
          <p style={{
            fontFamily:  "'Cairo', sans-serif",
            fontSize:    "0.72rem",
            color:       "rgba(255,255,255,0.2)",
            textAlign:   "center",
            margin:      0,
            letterSpacing:"0.05em",
          }}>
            © 2024 Emaar Properties
          </p>
        </div>
      </div>

      {/* Booking Modal */}
      <EmaarBookingModal open={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

// helper بسيط لنص الزرار (لو احتجت لاحقاً تتحكم فيه)
function texts() {
  return "تواصل معنا";
}

export default EmaarNavbar;